import ForgotPassword from './container';

export default ForgotPassword;



// WEBPACK FOOTER //
// ./src/views/Auth/ForgotPassword/index.js